module.exports = __webpack_public_path__ + "static/pressurewashing-5090737991c3bbdf3b17f7e9205accd6.jpg";